const data = [{
    id: 1,
    name: "HTML",
    src: require("../../Assets/TechStack/HTML.png")
},
{
    id: 2,
    name: "CSS",
    src: require("../../Assets/TechStack/CSS.png")
},
{
    id: 3,
    name: "Bootstrap",
    src: require("../../Assets/TechStack/Bootstrap.png")
},
{
    id: 4,
    name: "Tailwind",
    src: require("../../Assets/TechStack/Tailwind.png")
},
{
    id: 5,
    name: "Javascript",
    src: require("../../Assets/TechStack/Javascript.png")
},
{
    id: 6,
    name: "React",
    src: require("../../Assets/TechStack/React.png")
},
{
    id: 7,
    name: "Express",
    src: require("../../Assets/TechStack/Express.png"),
},
{
    id: 8,
    name: "Redux",
    src: require("../../Assets/TechStack/Redux.png"),
    
},
{
    id: 9,
    name: "Material UI",
    src: require("../../Assets/TechStack/MaterialUI.png"),
},
{
    id: 10,
    name: "MongoDB",
    src: require("../../Assets/TechStack/MongoDB.png")
},
{
    id: 11,
    name: "NodeJs",
    src: require("../../Assets/TechStack/NodeJs.png")
},
{
    id: 12,
    name: "Linux",
    src: require("../../Assets/TechStack/Linux.png")
},
{
    id: 13,
    name: "Python",
    src: require("../../Assets/TechStack/Python.png")
},
{
    id: 14,
    name: "SQL",
    src: require("../../Assets/TechStack/SQL.png")
},
{
    id: 15,
    name: "Bash",
    src: require("../../Assets/TechStack/Bash.png"),
},
{
    id: 16,
    name: "C++",
    src: require("../../Assets/TechStack/C++.png"),
},
{
    id: 17,
    name: "Docker",
    src: require("../../Assets/TechStack/Docker.png"),
},
{
    id: 18,
    name: "Git",
    src: require("../../Assets/TechStack/Git.png")
},
];

export default data;